<template>
  <h-tour-dialog v-model="show" dark>
    <p class="text-h6" v-text="__('tour3Text')" />
    <div class="my-8 text-subtitle-1">
      <div
        v-for="(option, i) in options"
        :key="i"
        class="ma-4"
      >
        <v-icon left v-text="icons[option.icon]" style="opacity:.8" />{{ __(option.text) }}
      </div>
    </div>
    <p><span class="primary--text">*</span> {{ __('tour3Full') }}</p>
  </h-tour-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HTourDialog from './Dialog'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HTourDialog,
    },

    props: {
      value: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      options: [
        { icon: 'divide', text: 'tour3Divide' },
        { icon: 'list', text: 'tour3Split' },
        { icon: 'cash', text: 'tour3Cash' },
        { icon: 'creditCard', text: 'tour3Card' },
      ],
    }),

    computed: {
      show: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
    },
  }
</script>
